/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showModal } from 'modules/navigation/navigation.actions';
import { MetamaskButton } from '../socialButtons';
import {
  Box,
  Image,
  LinkFont,
  SecondaryText,
  View,
  ButtonWithIcon,
  InlineLink,
} from 'modules/styled';
import { ButtonAnchor } from 'app/modules/styled/web';

const twitterIcon = require('public/img/icons/twitter_white.png');

// const redditIcon = require('public/img/icons/reddit.png');
// const redditIconComponent = (
//   <Image resizeMode={'contain'} source={redditIcon} w={3} h={3} mr={1.5} />
// );
const twitterIconComponent = (
  <Image
    resizeMode={'contain'}
    source={twitterIcon}
    sx={{ width: 4, height: 4, mr: 1.5 * 8.001 }}
  />
);

class SignupSocial extends Component {
  static propTypes = {
    location: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
  };

  render() {
    const { location, auth } = this.props;
    let { redirect } = queryString.parse(location.search);
    if (!redirect) redirect = location.pathname;
    const { invitecode } = auth;

    return (
      <View sx={{ alignItems: 'stretch' }}>
        <SecondaryText>Sign up for Relevant.</SecondaryText>
        <View
          sx={{
            flexDirection: ['column', 'row'],
            alignItems: ['stretch', 'center'],
            justifyContent: 'flex-start',
            mt: [7, 4],
          }}
        >
          <ButtonAnchor
            href={`/auth/twitter?invitecode=${invitecode}&redirect=${redirect}`}
            external
            rel="nofollow"
            sx={{ p: 0, bg: 'twitterBlue' }}
          >
            <ButtonWithIcon
              sx={{ bg: 'twitterBlue' }}
              image={twitterIconComponent}
              text="Sign up with Twitter"
            />
          </ButtonAnchor>
          <Box sx={{ mr: [0, 2], mt: [2, 0] }} />

          <MetamaskButton
            onPress={(e) => {
              e.preventDefault();
              this.props.actions.showModal('signupWeb3');
            }}
            text="Sign up with Metamask"
          />
          <Box sx={{ mr: [0, 2], mt: [3, 0] }} />

          <View sx={{ flex: 1, alignItems: ['center', 'flex-start'] }}>
            <InlineLink
              to={'#'}
              onClick={(e) => {
                e.preventDefault();
                // this.setState({ provider: 'email' });
                this.props.actions.showModal('signupEmail');
              }}
            >
              <LinkFont sx={{ color: 'blue' }}>Sign up with Email</LinkFont>
            </InlineLink>
          </View>
        </View>

        <View sx={{ flex: 1, alignItems: ['center', 'flex-start'] }}>
          <LinkFont sx={{ mt: 4 }}>
            Already registered?{' '}
            <LinkFont
              sx={{ color: 'blue' }}
              onClick={() => this.props.actions.showModal('login')}
            >
              Sign In
            </LinkFont>
          </LinkFont>
        </View>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  auth: state.auth,
  initialValues: {},
  enableReinitialize: true,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      showModal,
    },
    dispatch
  ),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignupSocial));
